module.exports = __webpack_public_path__ + "img/logo.023696a4.png";